import React from 'react'
import theme from '../../theme'
import Typography from '@mui/material/Typography'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import PropTypes from 'prop-types'

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        paddingBottom: 15,
    },
    icon: {
        marginRight: 15,
        color: theme.palette.informationIcon,
        alignSelf: 'stretch',
    },
    text: {
        color: 'rgba(60, 60, 60, 0.8)',
        fontSize: 14,
        lineHeight: '24px',
    },
    informationNotice: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 15,
        height: 'auto',
    },
}

/**
 * component for sidebar
 * @param children
 * @param classes
 * @returns {*}
 */
const information = ({ children, classes, title, style, nowrap }) => {
   try {

        return (<div style={{...styles.root, style}} >
            {(title)
            && (
                <Typography variant="subtitle1" style={{color: theme.palette.secondary.dark}}>Information</Typography>
            )}
            <div style={styles.informationNotice}>
                <InfoIcon style={styles.icon}/>
                <Typography noWrap={nowrap} style={styles.text}>
                    {children}
                </Typography>
            </div>
        </div>)
    }
    catch(e) {
        console.error(e)
    }
    return (<span></span>)
}

information.defaultProps = {
    title: false,
}

information.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    children: PropTypes.node.isRequired,
    title: PropTypes.bool,
    style: PropTypes.object,
    nowrap: PropTypes.bool
}

export default information
